export { DynamicPageComponent } from './dynamicPage.component';
export { DynamicPageModule } from './dynamicPage.module';
